import { render, staticRenderFns } from "./mobile-onboarding-page.vue?vue&type=template&id=15a03fa1"
import script from "./mobile-onboarding-page.vue?vue&type=script&lang=js"
export * from "./mobile-onboarding-page.vue?vue&type=script&lang=js"
import style0 from "./mobile-onboarding-page.vue?vue&type=style&index=0&id=15a03fa1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports